import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María González', 'Roberto Fernández', 'Laura Martínez', 'Carlos Rodríguez', 'Ana Silva', 'Patricia Vega', 'Jorge López', 'Silvia Díaz', 'Martín Acosta'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000);
    // Loop every 8-15 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        // Random delay between 8 and 15 seconds
        const delay = Math.random() * (15000 - 8000) + 8000;
        setTimeout(showNotification, delay);
      }
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-8">
      {isVisible && <motion.div initial={{
      x: 300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full" data-id="element-9">
          <div className="bg-[#FFF8E7] border-2 border-[#8B4513] rounded-lg shadow-xl p-4 flex items-center gap-3 relative overflow-hidden" data-id="element-10">
            {/* Vintage texture overlay effect */}
            <div className="absolute inset-0 opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" data-id="element-11"></div>

            <div className="bg-[#7C2D2D] rounded-full p-2 flex-shrink-0" data-id="element-12">
              <CheckCircle className="w-6 h-6 text-[#F4E8D8]" data-id="element-13" />
            </div>
            <div data-id="element-14">
              <p className="font-serif font-bold text-[#7C2D2D] text-sm leading-tight" data-id="element-15">
                ¡Nueva compra!
              </p>
              <p className="font-sans text-xs text-[#5D4037] mt-1" data-id="element-16">
                <span className="font-semibold" data-id="element-17">{currentName}</span> de{' '}
                {currentCity}
              </p>
              <p className="font-sans text-[10px] text-[#8B4513] opacity-80 mt-0.5" data-id="element-18">
                Compró el Pack Historia hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}